export default class Header {
    constructor() {
        this.notificationBarHeight = 0;
        this.lastScrollTop = 0;
        this.scrollTimeout = null;
        this.isAtTop = true;
        this.header = document.querySelector('header');
        if (!this.header)
            return;
        this.desktopNavigationColumn = this.header.querySelector('.row .col-navigation');
        this.notificationBar = document.querySelector('.notification-bar');
        this.notificationBarHeight = this.notificationBar ? this.notificationBar.offsetHeight : 0;
        this.checkScrollPosition(); // Initial check to set header position correctly
        this.init();
        this.showHeader(); // Always show on initial load
    }
    init() {
        this.calculateHeaderSizes();
        this.addEventListeners();
    }
    calculateHeaderSizes() {
        this.headerHeight = this.header.offsetHeight / 2 - 55;
        // set style variable to body --headerHeight - for page heros
        document.body.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        // Set desktop navigation width style attribute to use for hero width
        this.heroContentWidth = this.desktopNavigationColumn.offsetWidth;
        document.body.style.setProperty('--hero-title-w', `${this.heroContentWidth}px`);
    }
    addEventListeners() {
        window.addEventListener('resize', () => this.calculateHeaderSizes(), { passive: true });
        window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
    }
    handleScroll() {
        if (this.scrollTimeout !== null) {
            window.cancelAnimationFrame(this.scrollTimeout);
        }
        this.scrollTimeout = window.requestAnimationFrame(() => {
            this.checkScrollPosition();
            this.scrollTimeout = null;
        });
    }
    checkScrollPosition() {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        this.isAtTop = currentScroll <= 5; // 5px threshold for "at top"
        this.header.style.setProperty('--headerTop', `1`);
        if (this.isAtTop && this.notificationBar) {
            this.header.style.setProperty('--headerTop', `${this.notificationBarHeight}px`);
        }
        // Always show if at top or scrolling up
        if (this.isAtTop || currentScroll < this.lastScrollTop) {
            this.showHeader();
        }
        // Only hide if scrolling down past threshold
        else if (currentScroll > this.lastScrollTop && currentScroll > this.headerHeight) {
            this.hideHeader();
        }
        this.lastScrollTop = currentScroll;
    }
    showHeader() {
        this.header.classList.remove('header-hidden');
        if (!this.isAtTop) {
            this.header.classList.add('header-scrolled');
        }
        else {
            this.header.classList.remove('header-scrolled');
        }
    }
    hideHeader() {
        this.header.classList.add('header-hidden');
        this.header.classList.add('header-scrolled');
    }
}
